import styled from 'styled-components';

function BarrioLifestyle({ barrio }) {
  if (!barrio || !barrio.highlights?.length) return null;

  return (
    <Wrapper>
      <Header>
        <Icon>🏡</Icon>
        <Title>Estilo de vida en {barrio.name}</Title>
      </Header>

      <Grid>
        {barrio.highlights.map((item, index) => (
          <Item key={index}>
            <Bullet />
            {item}
          </Item>
        ))}
      </Grid>
    </Wrapper>
  );
}

export default BarrioLifestyle;

/* ================= STYLES ================= */

const Wrapper = styled.section`
  margin-top: 48px;
  padding: 32px;
  border-radius: 24px;
  background: #fafafa;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
`;

const Icon = styled.span`
  font-size: 20px;
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
`;

const Grid = styled.div`
  display: grid;
  gap: 12px;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #444;
`;

const Bullet = styled.span`
  width: 6px;
  height: 6px;
  background: #C66F4E;
  border-radius: 50%;
  margin-right: 10px;
`;